const ALLOWED_TAGS = new Set(["B", "STRONG", "BR"]);

export function sanitizeHtml(html: string): string {
    const template = document.createElement("template");
    template.innerHTML = html;
    const sanitized = sanitizeChildren(template.content);
    const output = document.createElement("template");
    for (const node of sanitized) output.content.appendChild(node);
    return output.innerHTML;
}

function sanitizeChildren(parent: ParentNode): Node[] {
    const result: Node[] = [];
    for (const child of Array.from(parent.childNodes)) {
        result.push(...sanitizeNode(child));
    }
    return result;
}

function sanitizeNode(node: Node): Node[] {
    if (node.nodeType === Node.TEXT_NODE) {
        return [document.createTextNode(node.textContent ?? "")];
    }
    if (!(node instanceof HTMLElement)) return [];
    const children = sanitizeChildren(node);
    if (!ALLOWED_TAGS.has(node.tagName)) return children;
    const clone = document.createElement(node.tagName.toLowerCase());
    if (node.tagName !== "BR") {
        for (const child of children) clone.appendChild(child);
    }
    return [clone];
}
